import { HttpClient } from "@angular/common/http";
import { Subject, merge, of as observableOf } from "rxjs";
import { catchError, shareReplay, map, takeUntil, switchMap } from 'rxjs/operators';
import { DataService, LoginService } from "./base/data.service";
import { SettingsService } from '../../settings';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../auth/login.service";
import * as i3 from "../../settings/settings.service";
const API_ENDPOINT = 'api/v1/permission/';
const CACHE_SIZE = 1;
export class UserService extends DataService {
    constructor(httpClient, 
    //@Inject(LoginService) loginService
    loginService, settingsService) {
        super(httpClient, loginService);
        this.settingsService = settingsService;
        this.reloadIsAdmin$ = new Subject();
        this.reloadHasAccess$ = new Subject();
        //On Change userProfile:
        //                    Reload IsAdmin
        //                    Reload SubFleetId
        loginService.userProfile$
            .pipe(takeUntil(this.onDestroy$))
            //.
            .subscribe(userProfile => {
            //if (userProfile) {
            this.forceReloadIsAdmin();
            this.forceReloadSubFleetId();
            //}
        });
    }
    getCountries() {
        return this.httpClient
            .get(/*API_ENDPOINT*/ 'api/v1/common/countries', this.getRequestOptions())
            .pipe(map((data) => {
            if (data && data.success) {
                return data.result;
            }
            return observableOf(false);
        }), catchError(this.handleError));
    }
    hasAccess() {
        if (!this.cacheHasAccess$) {
            const updates$ = this.reloadHasAccess$
                .pipe(switchMap(() => observableOf(true)));
            this.cacheHasAccess$ = merge(observableOf(true), updates$)
                .pipe(switchMap((value, index) => this.requestHasAccess()), shareReplay(CACHE_SIZE));
        }
        return this.cacheHasAccess$;
    }
    forceReloadSubFleetId() {
        this.reloadHasAccess$.next(); //we simply propagate a ghost value causing all active Observers to be notified
    }
    requestHasAccess() {
        return this.httpClient
            .get(API_ENDPOINT + 'has-access', this.getRequestOptions())
            .pipe(catchError(this.handleError))
            .pipe(map((hasAccess) => hasAccess));
    }
    get isAdmin() {
        if (!this.cacheIsAdmin$) {
        }
        return this.cacheIsAdmin$;
    }
    // Public facing API to force the cache to reload the data
    forceReloadIsAdmin() {
        this.reloadIsAdmin$.next(); //we simply propagate a ghost value causing all active Observers to be notified
    }
    requestIsAdmin() {
        return this.httpClient
            .get(API_ENDPOINT + 'is-admin', this.getRequestOptions());
    }
}
UserService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UserService_Factory() { return new UserService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.LoginService), i0.ɵɵinject(i3.SettingsService)); }, token: UserService, providedIn: "root" });
